export default "__VITE_ASSET__DNCx14s2__"